import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { WalletVesClientService } from '../../services/wallet-ves-client.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { AppState } from 'src/app/app.reducer';
import { PageEvent } from '@angular/material/paginator';
import { puedeRecargarVes } from 'src/app/shared/utils/saldo-ves';

interface ReferenciaVes {
  id: string;
  banco: string;
  cuenta: string;
  tipoCuenta: string;
  referencia: string;
  monto: number;
  titular: string;
  status: string;
  motivoRechazo: string | null;
  createdAt: string;
  updatedAt: string;
}

@Component({
  selector: 'app-referencias-ves',
  templateUrl: './referencias-ves.component.html',
  styleUrls: ['./referencias-ves.component.sass'],
})
export class ReferenciasVesComponent implements OnInit, OnDestroy {
  referencias: ReferenciaVes[] = [];
  page = 1;
  limit = 20;
  total = 0;
  totalPages = 0;
  loading = false;
  expandedCardId: string | null = null;

  private authSubscription?: Subscription;

  constructor(
    private walletVesClientService: WalletVesClientService,
    private spinner: SpinnerService,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.authSubscription = this.store.select('auth').subscribe(({ user }: any) => {
      // Se decide con el usuario ya cargado, no con el store todavía vacío.
      if (!user?.usuarioId) return;
      // Solo el VE: son las referencias de su recarga de bolívares.
      // 30/10/2026: el chileno no recarga bolívares, así que no tiene
      // referencias que informar ni que revisar (se le quitó «Depósitos VES»
      // del menú). Si entra por URL, vuelve al inicio.
      if (!puedeRecargarVes(user.tipoId)) {
        this.router.navigate(['/wallet/home']);
        return;
      }
      this.loadReferencias();
    });
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
  }

  async loadReferencias(): Promise<void> {
    this.loading = true;
    const spinnerRef = this.spinner.start();
    try {
      const res: any = await firstValueFrom(
        this.walletVesClientService.getMyReferenciasVes(this.page, this.limit)
      );
      this.referencias = res?.data?.items || [];
      this.total = res?.data?.total || 0;
      this.totalPages = res?.data?.totalPages || 0;
    } catch (error) {
      console.error('Error cargando referencias VES:', error);
      this.referencias = [];
    } finally {
      this.loading = false;
      this.spinner.stop(spinnerRef);
    }
  }

  onPageChange(event: PageEvent): void {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    this.loadReferencias();
  }

  toggleCard(id: string): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  getStatusLabel(status: string): string {
    const labels: { [key: string]: string } = {
      PENDING: 'Pendiente',
      APPROVED: 'Aprobada',
      REJECTED: 'Rechazada',
    };
    return labels[status?.toUpperCase()] || status || '';
  }

  getStatusBg(status: string): string {
    const colors: { [key: string]: string } = {
      PENDING: '#eab308',
      APPROVED: '#16a34a',
      REJECTED: '#dc2626',
    };
    return colors[status?.toUpperCase()] || '#6b7280';
  }

  goToRecharge(): void {
    // 30/10/2026: sin `?moneda=VES`. Acá solo llega el VE, y `rechargeAccount`
    // ya le muestra la recarga de bolívares (el parámetro era del chileno).
    this.router.navigate(['/wallet/client/rechargeAccount']);
  }

  goToHome(): void {
    this.router.navigate(['/wallet/home']);
  }
}
